<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <br/>
    <br/>
    <h1>User info: </h1>
    <table v-if="firebaseDB_User && firebaseDB_User.userDetails">
      <tbody>
        <tr><td>Email:</td><td>{{firebaseDB_User.userDetails.email}}</td></tr>
        <tr><td>firstName:</td><td>{{firebaseDB_User.userDetails.firstName}}</td></tr>
        <tr><td>lastName:</td><td>{{firebaseDB_User.userDetails.lastName}}</td></tr>
        <tr><td>accessRoleKey:</td><td>{{firebaseDB_User.userDetails.accessRoleKey}}</td></tr>
      </tbody>
    </table>
    <h3 v-else>User is logged OUT!!!</h3>
    <br/>
    <br/>
    <h2>Essential Links</h2>
    <router-link to="/hello-world"><b>Go to Hello World!!!>></b></router-link>
    <br/>
    <br/>
    <ul>
      <li><a href="https://vuejs.org" target="_blank">Core Docs</a></li>
      <li><a href="https://forum.vuejs.org" target="_blank">Forum</a></li>
      <li><a href="https://gitter.im/vuejs/vue" target="_blank">Gitter Chat</a></li>
      <li><a href="https://twitter.com/vuejs" target="_blank">Twitter</a></li>
      <br>
      <li><a href="http://vuejs-templates.github.io/webpack/" target="_blank">Docs for This Template</a></li>
    </ul>
    <h2>Ecosystem</h2>    
    <ul>
      <li><a href="http://router.vuejs.org/" target="_blank">vue-router</a></li>
      <li><a href="http://vuex.vuejs.org/" target="_blank">vuex</a></li>
      <li><a href="http://vue-loader.vuejs.org/" target="_blank">vue-loader</a></li>
      <li><a href="https://github.com/vuejs/awesome-vue" target="_blank">awesome-vue</a></li>
    </ul>
    <button v-on:click="logout">Logout</button>
  </div>
</template>

<script>
import Firebase from 'firebase';

export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      firebaseDB_User: null
    }
  },
  methods: {
    logout: function() {
      Firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    }
  },
  beforeCreate: function () {
    console.log('||-beforeCreate: Hello comp');
    // let currentUser = firebase.auth().currentUser;
    // console.log('auth() currentUser: ' + JSON.stringify(currentUser, null, 2));
  },
  created: function () {
    console.log('||-created: Hello comp');
    if (this.$parent.firebaseDB_User && this.$parent.firebaseDB_User.currentUser){
      this.firebaseDB_User = this.$parent.firebaseDB_User;
      //console.log('Hello this.$parent.firebaseDB_User : ' + JSON.stringify(this.$parent.firebaseDB_User, null, 2));
    }  
  },
  mounted: function () {
    console.log('||-mounted: Hello comp');
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue